import { render } from "./Button.vue?vue&type=template&id=fa50aad2"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
script.render = render

export default script